module.exports = __webpack_public_path__ + "img/academy_resillience-sm.53308afd.png";